var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7592 17.6998L14.8596 13.0369C16.087 11.6105 16.7595 9.82538 16.7595 7.98195C16.7595 3.5795 12.9999 0 8.38103 0C7.25191 0 6.1555 0.210464 5.12202 0.627481C4.1238 1.03125 3.22785 1.60573 2.45871 2.33845C1.68956 3.07117 1.08411 3.9247 0.660287 4.87571C0.222553 5.85943 0 6.90392 0 7.98049C0 12.3829 3.75963 15.9624 8.37848 15.9624C10.316 15.9624 12.1873 15.3217 13.6846 14.1525L18.5791 18.8153C18.7362 18.965 18.9448 19.0476 19.1665 19.0476C19.3891 19.0476 19.5986 18.9658 19.754 18.8153C20.0813 18.5098 20.0813 18.0085 19.7581 17.7007L19.7592 17.6998ZM15.1011 7.97955C15.1011 11.5106 12.0859 14.3807 8.38202 14.3807C4.67559 14.3807 1.6629 11.5082 1.6629 7.97955C1.6629 4.44994 4.6781 1.57843 8.38202 1.57843C12.087 1.57843 15.1011 4.45093 15.1011 7.97955Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.553cc5cd928a1935be299fab95ebccef.svg";
export { ForwardRef as ReactComponent };